import React from "react";
import { Link } from "react-router-dom";
import { useT } from "../i18n/LanguageContext";
import { SectionTag } from "../components/Section";
import { PDF } from "../i18n/photos";
import { ArrowUpRight } from "lucide-react";

export default function SimpPage() {
  const { t } = useT();
  return (
    <main className="pt-32 md:pt-40" data-testid="page-simp">
      {/* Hero */}
      <section className="relative overflow-hidden border-b border-white/10 py-16 md:py-24">
        <img src={PDF.identityPortrait} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" loading="lazy" />
        <div className="absolute inset-0 grid-bg opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-bg/70 via-brand-bg/90 to-brand-bg" />
        <div className="absolute inset-0 radial-glow opacity-50" />
        <div className="relative mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <SectionTag>{t("simp.tag")}</SectionTag>
          <h1 className="mt-6 max-w-5xl font-heading text-4xl font-medium tracking-tighter text-white sm:text-5xl lg:text-6xl">
            {t("simp.hero_title")}
          </h1>
          <p className="mt-6 max-w-3xl text-base text-brand-textDim sm:text-lg">{t("simp.hero_sub")}</p>
          <Link
            to="/contact"
            data-testid="simp-page-cta"
            className="mt-10 inline-flex items-center gap-2 bg-brand-red px-6 py-3 font-mono text-[11px] uppercase tracking-[0.22em] text-white transition-colors hover:bg-brand-redHover"
          >
            {t("simp.cta")} <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </section>

      {/* What it does + How */}
      <section className="border-b border-white/10 py-20 md:py-28">
        <div className="mx-auto grid max-w-[1440px] gap-12 px-6 lg:grid-cols-12 md:px-12 lg:px-16">
          <div className="lg:col-span-6">
            <p className="font-mono-tag">01 · {t("simp.section1.title")}</p>
            <h2 className="mt-5 font-heading text-3xl tracking-tight text-white sm:text-4xl">
              {t("simp.section1.title")}
            </h2>
            <p className="mt-6 text-base leading-relaxed text-brand-textDim">
              {t("simp.section1.body")}
            </p>
            <div className="mt-8 overflow-hidden border border-white/10">
              <img src={PDF.identityPortrait} alt="" className="w-full opacity-90" loading="lazy" />
            </div>
          </div>
          <div className="lg:col-span-6">
            <p className="font-mono-tag">02 · {t("simp.section2.title")}</p>
            <h2 className="mt-5 font-heading text-3xl tracking-tight text-white sm:text-4xl">
              {t("simp.section2.title")}
            </h2>
            <p className="mt-6 text-base leading-relaxed text-brand-textDim">
              {t("simp.section2.body")}
            </p>
            <div className="mt-8 overflow-hidden border border-white/10">
              <img src={PDF.serverRoomCams} alt="" className="w-full opacity-90" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* Bullets grid */}
      <section className="border-b border-white/10 py-20 md:py-28">
        <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16">
          <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/5 sm:grid-cols-2 lg:grid-cols-3">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i} className="flex items-start gap-4 bg-brand-bg p-8">
                <span className="font-mono text-[10px] tracking-[0.25em] text-brand-red">
                  {String(i).padStart(2, "0")}
                </span>
                <p className="text-base text-white">{t(`simp.bullet${i}`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
